// Sidebar_Interactions.tsx
import Sidebar, { PageItem } from "./sidebar";
import {
  Campaign,
  QuestionAnswer,
  Event,
  Folder,
  Sms,
  Email,
  Description,
  MarkunreadMailbox,
  DoorFront,
  School,
} from "@mui/icons-material";

const pages: PageItem[] = [
  { name: "Text Messages", link: "/interactions/text-messages/", icon: <Sms /> },
  { name: "Emails", link: "/interactions/emails/", icon: <Email /> },
  { name: "Flyers", link: "/interactions/flyers/", icon: <Description /> },
  { name: "Direct Mail", link: "/interactions/direct-mail/", icon: <MarkunreadMailbox /> },
  { name: "Conversations", link: "/interactions/conversations/", icon: <QuestionAnswer /> },
  { name: "Events", link: "/interactions/events/", icon: <Event />  },
  //{ name: "Files", link: "/interactions/files/", icon: <Folder /> },
];

export default function Sidebar_Interactions() {
  return <Sidebar pages={pages} primaryColorKey="interactionsPrimary" />;
}
